import {InputText, Select} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemBdName, FormItemBdNo} from '../BD/FormChooseBd.jsx'
import RuleType from './RuleType.jsx'
import Model from './ModelBdrule.mjs'

export const FormItemRuleTitle = props => (
    <FormItemBizProp
        Model={Model}
        prop="ruleTitle"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemRuleType = props => (
    <FormItemBizProp
        Model={Model}
        prop="ruleType"
        name="ruleTypes"
        {...props}
    >
        <Select
            allowClear
            getOptionKey={e => e[0]}
            getOptionLabel={e => e[1]}
            mode="multiple"
            options={RuleType}
        />
    </FormItemBizProp>
)

export default function FormChooseBdrule(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemBdNo />
            <FormItemBdName />
            <FormItemRuleTitle />
            <FormItemRuleType />
        </FormChooseDesign>
    )
}
